module.exports = __webpack_public_path__ + "static/media/loading_icon.fdee536c.gif";